// extracted by mini-css-extract-plugin
export var big = "steps-module--big--A0phq";
export var bold = "steps-module--bold---dalz";
export var center = "steps-module--center--l65xd";
export var middle = "steps-module--middle--wS+sZ";
export var red = "steps-module--red--MKilV";
export var table = "steps-module--table--RVTjl";
export var text_container = "steps-module--text_container--I5wtJ";